import { render } from "./IntersectionObserver.vue?vue&type=template&id=6908ad69&ts=true"
import script from "./IntersectionObserver.vue?vue&type=script&lang=ts"
export * from "./IntersectionObserver.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__